import React from 'react';
import { ContextWidget } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { DefaultContextWidget } from '../_utils/asDefaultWidget';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { PageMembershipMatchingAttributesBlock }
  from '../../_blocks/PageMembershipMatchingAttributes/PageMembershipMatchingAttributesBlock';

export type PageMembershipMatchingAttributesWidget =
  ContextWidget<PageMembershipMatchingAttributesBlock, WidgetType.pagemembershipmatchingattributes>;

export function PageMembershipMatchingAttributesWidget(
  { elementType, ...props }: PageMembershipMatchingAttributesWidget) {
  const { t } = useSonTranslation('PageMembershipMatchingAttributes');
  const title = t('widgetTitle');

  return <DefaultContextWidget elementType={elementType} icon={Icons.AUTOMATIC_ASSIGNMENT} title={title} {...props} />;
}
